import { IFlowyProject, IFlowyRoute, IGizmo } from '../../types';

interface IParams {
  config?: IFlowyProject;
  context: {
    basePath: string;
    path: string;
  };
}

interface IReturn {
  // rootGizmoConfig?: IGizmo;
  flowyRoutes: IFlowyRoute[];
}

function init({ config }: IParams): Promise<IReturn> {
  return new Promise<IReturn>(async resolve => {
    const flowyRoutes: IFlowyRoute[] = [];

    if (config?.navigation?.routes) {
      for (const route of config.navigation.routes) {
        // TODO: support for annex forms
        //! Right now we're only looking for views, we still need the forms
        const rootGizmoConfig: IGizmo | undefined = config?.views?.gizmos.find(
          g => route.ops?.route?.rootGizmoFid === g.fid
        );

        let flowyPath: string | undefined = route.ops?.route?.path;

        if (route.ops?.route?.index === true) {
          flowyPath = '/';
        }

        if (flowyPath && rootGizmoConfig) {
          const flowyRoute: IFlowyRoute = {
            path: flowyPath,
            configs: [rootGizmoConfig],
          };
          if (flowyPath === '/login' || flowyPath === '/sign_up') {
            flowyRoute.access = 'public';
          }
          flowyRoutes.push(flowyRoute);
        }
      }

      flowyRoutes.push({
        path: '/rg',
        configs: [],
      });
    }

    resolve({ flowyRoutes });
  });
}

export default init;
